import { render, staticRenderFns } from "./CmsSafeAccident.vue?vue&type=template&id=0af4f7d7&scoped=true&"
import script from "./CmsSafeAccident.vue?vue&type=script&lang=js&"
export * from "./CmsSafeAccident.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af4f7d7",
  null
  
)

export default component.exports